import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { User, Lock, Mail } from 'lucide-react';
import './LoginAnimated.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Login({ onLogin }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [nome, setNome] = useState('');
  const [role, setRole] = useState('gestor');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isRegister) {
        await axios.post(`${API}/auth/register`, { nome, email, senha, role });
        toast.success('Conta criada com sucesso!');
        setIsRegister(false);
        setNome('');
        setSenha('');
        setEmail('');
      } else {
        const response = await axios.post(`${API}/auth/login`, { email, senha });
        toast.success('Login realizado com sucesso!');
        onLogin(response.data.user, response.data.access_token);
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Erro ao processar solicitação');
    } finally {
      setLoading(false);
    }
  };

  const toggleMode = () => {
    setIsRegister(!isRegister);
    setNome('');
    setEmail('');
    setSenha('');
  };

  return (
    <div className="login-container">
      <div className={`login-wrapper ${isRegister ? 'active' : ''}`}>
        {/* Formulário de Login */}
        <div className="form-container login-form">
          <form onSubmit={handleSubmit}>
            <h1>Login</h1>
            
            <div className="input-group">
              <User className="input-icon" size={20} />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <div className="input-group">
              <Lock className="input-icon" size={20} />
              <input
                type="password"
                placeholder="Senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <a 
              href="/esqueceu-senha" 
              className="forgot-password"
              onClick={(e) => {
                e.preventDefault();
                navigate('/esqueceu-senha');
              }}
            >
              Esqueceu sua senha?
            </a>

            <button 
              type="submit" 
              className="submit-btn"
              disabled={loading}
            >
              {loading ? 'Entrando...' : 'Entrar'}
            </button>

            <p className="toggle-text">
              Não tem uma conta?{' '}
              <span onClick={toggleMode} className="toggle-link">
                Cadastre-se
              </span>
            </p>
          </form>
        </div>

        {/* Formulário de Cadastro */}
        <div className="form-container register-form">
          <form onSubmit={handleSubmit}>
            <h1>Cadastro</h1>
            
            <div className="input-group">
              <User className="input-icon" size={20} />
              <input
                type="text"
                placeholder="Nome completo"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required={isRegister}
                disabled={loading}
              />
            </div>

            <div className="input-group">
              <Mail className="input-icon" size={20} />
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required={isRegister}
                disabled={loading}
              />
            </div>

            <div className="input-group">
              <Lock className="input-icon" size={20} />
              <input
                type="password"
                placeholder="Senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required={isRegister}
                disabled={loading}
              />
            </div>

            <div className="input-group">
              <select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                disabled={loading}
                className="role-select"
              >
                <option value="gestor">Gestor</option>
                <option value="administrador">Administrador</option>
              </select>
            </div>

            <button 
              type="submit" 
              className="submit-btn"
              disabled={loading}
            >
              {loading ? 'Cadastrando...' : 'Cadastrar'}
            </button>

            <p className="toggle-text">
              Já tem uma conta?{' '}
              <span onClick={toggleMode} className="toggle-link">
                Faça login
              </span>
            </p>
          </form>
        </div>

        {/* Painel Welcome */}
        <div className="welcome-panel">
          <div className="welcome-content">
            <img 
              src="/logo-remax.png" 
              alt="Silver Start Logo" 
              className="welcome-logo"
            />
            <h2>{isRegister ? 'Bem-vindo!' : 'Bem-vindo de volta!'}</h2>
            <p>
              {isRegister 
                ? 'Cadastre-se agora e tenha acesso a todas as funcionalidades do sistema.'
                : 'Sistema de gestão RE/MAX Silver Start. Gerencie seu onboarding e documentos de forma eficiente.'
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
